// Defines the different error types a user can run in to while running a resubmission
export const ERROR_ORDER_LIMIT_EXCEEDED = 'orderLimitExceeded';
export const ERROR_CSV_DATA_ISSUE = 'csvDataIssue';

export const RESUBMIT_ORDERS_LIMIT = 500;
